import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* REST API */
import { chats, messages, send } from "../../api/Support"

/* Widgets */
import { Layout } from "../Table"

/* Components */
import { Avatar } from "../../components"

/* Helpers */
import { utils } from "../../helpers"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Sweet Alert */
import Swal from "../../helpers/alert"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Moment */
import moment from "moment"
import "moment/locale/ru"


/* HEIGHT OF THE EMPTY INPUT — THE TEXTAREA GROWS FROM IT AND RETURNS TO IT */
const INPUT_HEIGHT = 42

/* THE INPUT STOPS GROWING HERE AND STARTS TO SCROLL */
const INPUT_MAX = 140

/* THE SEARCH APPEARS ONLY WHEN THE LIST DOES NOT FIT A SINGLE LOOK */
const SEARCH_FROM = 5


/* Widget Chat */
class Chat extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,

            /* Chat */
            chatStatus: "loading",
            chats: [],
            search: "",

            /* Messages */
            active: null,
            messageStatus: "loading",
            messages: [],

            /* Bottom Input */
            message: "",
            sending: false,
        }
    }

    /* Open */
    open = () => {

        /* Open Modal */
        this.setState({ visible: true })

        /* Load Action */
        this.load()

        /* Register Socket Events */
        this.socketEvents()

    }

    /* Close */
    close = () => {

        /* Fields */
        const { updateBadge } = this.props

        /* Clear */
        this.setState({
            visible: false,
            chatStatus: "loading",
            chats: [],
            search: "",
            active: null,
            messageStatus: "loading",
            messages: [],
            message: "",
            sending: false,
        })

        /* Update Badge */
        updateBadge()
    }

    /* Socket Events */
    socketEvents = () => {

        /* Fields */
        const { socket } = this.props

        /* On Admin Answer */
        socket.on("adminSupportAnswer", (data) => {

            /* Fields */
            const { active } = this.state

            /* Load Messages */
            if (active && active.player === data.player) {
                this.messages()
            }

            /* Load Chats */
            this.load()

        })

        /* On Support Message */
        socket.on("supportMessage", (data) => {

            /* Fields */
            const { active } = this.state

            /* Load Messages */
            if (active && active.player === data.player) {
                this.messages()
            }

            /* Load Chats */
            this.load()

        })

    }


    /* Load Action */
    load = (reload = false) => {

        /* Reload */
        if (reload) {
            this.setState({ chatStatus: "loading", chats: [] })
        }

        /* Load Chats */
        chats().then((response) => {
            if (response.status === 200) {
                this.setState({ chatStatus: "ok", chats: response.data })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ chatStatus: "permission", chats: [] })
            }
            else if (response.status === 498) {
                this.setState({ chatStatus: "key", chats: [] })
            }
            else {
                this.setState({ chatStatus: "error", chats: [] })
            }
        }).catch(() => {
            this.setState({ chatStatus: "network", chats: [] })
        })
    }


    /* Load Message */
    messages = (reload = false) => {

        /* Fields */
        const { active } = this.state

        /* Check Active */
        if (!active) {
            return
        }

        /* Reload */
        if (reload) {
            this.setState({ messageStatus: "loading", messages: [] })
        }

        /* Load Messages */
        messages({ chatID: active.id }).then((response) => {
            if (response.status === 200) {
                this.setState({ messageStatus: "ok", messages: response.data })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ messageStatus: "permission", messages: [] })
            }
            else if (response.status === 498) {
                this.setState({ messageStatus: "key", messages: [] })
            }
            else {
                this.setState({ messageStatus: "error", messages: [] })
            }
        }).catch(() => {
            this.setState({ messageStatus: "network", messages: [] })
        })

    }


    /* Send Action */
    send = () => {

        /* Fields */
        const { active, message, sending } = this.state
        const { socket } = this.props

        /* Fields */
        const text = message.trim()

        /* Check Message */
        if (text.length === 0) {
            return
        }

        /* Check Active */
        if (!active || sending) {
            return
        }

        /* Start Sending */
        this.setState({ sending: true })

        /* Send Message */
        send({ message: text, chatID: active.id }).then((response) => {
            if (response.status === 200) {

                /* Load Action */
                this.load()

                /* Set Message — the list is sorted from the newest to the oldest */
                this.setState((state) => ({ messages: [response.data, ...state.messages] }))

                /* Emit Answer */
                socket.emit("adminSupportAnswer", { player: active.player, table: active.table, message: text, type: "admin", name: "Служба поддержки" })
            }
            else {
                Swal.fire(utils.notification(t("swal.generic"), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
        }).finally(() => {

            /* Clear Input */
            this.setState({ sending: false, message: "" })

            /* Reset Height */
            if (this._textarea) {
                this._textarea.style.height = `${INPUT_HEIGHT}px`
            }
        })

    }

    /* Handle Change */
    handleChange = (event) => {
        this.setState({ message: event.target.value })
        this._textarea.style.height = "auto"
        this._textarea.style.height = `${Math.min(this._textarea.scrollHeight, INPUT_MAX)}px`
    }

    /* Handle Key Down — Enter sends the answer, Shift + Enter breaks the line */
    handleKeyDown = (event) => {

        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault()
            this.send()
        }
    }


    /* TIME OF A ROW — TODAY KEEPS THE CLOCK, THE REST KEEPS THE DAY */
    _time = (date) => {

        /* Check Date */
        if (!date) {
            return ""
        }

        /* Fields */
        const value = moment(date)

        /* Today */
        if (value.isSame(moment(), "day")) {
            return value.format("HH:mm")
        }

        /* Yesterday */
        if (value.isSame(moment().subtract(1, "day"), "day")) {
            return t("support.yesterday")
        }

        /* This Year */
        if (value.isSame(moment(), "year")) {
            return value.format("D MMM")
        }

        return value.format("DD.MM.YY")
    }

    /* LABEL OF A DAY DIVIDER */
    _day = (date) => {

        /* Fields */
        const value = moment(date)

        /* Today */
        if (value.isSame(moment(), "day")) {
            return t("support.today")
        }

        /* Yesterday */
        if (value.isSame(moment().subtract(1, "day"), "day")) {
            return t("support.yesterday")
        }

        /* This Year */
        if (value.isSame(moment(), "year")) {
            return value.format("D MMMM")
        }

        return value.format("D MMMM YYYY")
    }


    /* Draw Button */
    _button = () => {

        /* Fields */
        const { sending, message } = this.state

        /* Sending */
        if (sending) {
            return (
                <div className="chat--message-button loading">
                    <LoadingOutlined />
                </div>
            )
        }

        return (
            <div onClick={() => this.send()} className={`chat--message-button ${message.trim().length === 0 ? "disabled" : ""}`}>
                <img src="/images/send.png" alt="Send" />
            </div>
        )
    }

    /* Draw Input */
    _input = () => {

        /* Fields */
        const { message } = this.state

        return (
            <div className="chat--message-bottom">

                <textarea
                    ref={(ref) => this._textarea = ref}
                    value={message}
                    onChange={this.handleChange}
                    onKeyDown={this.handleKeyDown}
                    rows={1}
                    placeholder={t("support.inputPlaceholder")}
                    className="chat--input"
                />

                {/* Draw Button */}
                {this._button()}

            </div>
        )
    }

    /* Open Messages */
    openMessages = (item) => {

        /* Fields */
        const { chats } = this.state

        /* Get Index */
        const index = chats.findIndex((e) => parseInt(e.id) === parseInt(item.id))

        /* Check Index */
        if (index > -1) {
            chats[index].unread = 0
        }

        /* Save */
        this.setState({ active: item, chats }, () => this.messages(true))
    }

    /* FILTERED CHATS — THE SEARCH WALKS THE PLAYER, THE GAME AND THE LAST MESSAGE */
    filtered = () => {

        /* Fields */
        const { chats, search } = this.state

        /* Check Search */
        if (search.trim().length === 0) {
            return chats
        }

        /* Fields */
        const query = search.trim().toLowerCase()

        /* Send Result */
        return chats.filter((item) => [item.user, item.player, item.game, item.studio, item.operator, item.message]
            .some((value) => value && String(value).toLowerCase().includes(query)))
    }

    /* Draw Search */
    _search = () => {

        /* Fields */
        const { chats, search } = this.state

        /* Check Chats — a short list needs no search */
        if (chats.length < SEARCH_FROM) {
            return null
        }

        return (
            <div className="chat--search">

                <img src="/images/search.png" alt="Search" className="chat--search-icon" />

                <input
                    value={search}
                    onChange={(event) => this.setState({ search: event.target.value })}
                    placeholder={t("support.searchPlaceholder")}
                />

                {search.length > 0 && (
                    <div onClick={() => this.setState({ search: "" })} className="chat--search-clear">
                        <img src="/images/close.png" alt="Clear" />
                    </div>
                )}

            </div>
        )
    }

    /* Draw Chats */
    _chats = () => {

        /* Fields */
        const list = this.filtered()

        /* Empty Search */
        if (list.length === 0) {
            return (
                <div className="chat--container">
                    {this._search()}
                    <div className="chat--empty">
                        <img src="/images/search.png" alt="Search" />
                        <p>{t("support.notFound")}</p>
                    </div>
                </div>
            )
        }

        return (
            <div className="chat--container">

                {/* Draw Search */}
                {this._search()}

                {list.map((item, index) =>
                    <div
                        onClick={() => this.openMessages(item)}
                        className={`chat--element ${utils.checkValue(item.unread, 0) > 0 ? "unread" : ""}`}
                        key={`${index}`}
                    >

                        <div className="chat--element-ava">
                            <Avatar uri={utils.ava(item.ava, parseInt(item.isTester) === 1 ? "test" : null)} size={48} />
                        </div>

                        <div className="chat--element-text">

                            <div className="chat--element-top">

                                <div className="chat--element-title">
                                    <span className="chat--element-text-name">{utils.checkValue(item.user, "—")}</span>
                                    {item.operator && <span className="chat--element-operator">{item.operator}</span>}
                                </div>

                                <div className="chat--element-date">{this._time(item.lastUpdated)}</div>

                            </div>

                            <div className="chat--element-tags">
                                <span className="chat--tag player">{utils.checkValue(item.player, "—")}</span>
                                {item.game && <span className="chat--tag">{item.game}</span>}
                                {item.studio && <span className="chat--tag studio">{item.studio}</span>}
                            </div>

                            <div className="chat--element-bottom">

                                <div className="chat--element-text-message">
                                    {item.messageType === "admin" && <b>{`${t("support.you")}: `}</b>}
                                    {utils.checkValue(item.message, "...")}
                                </div>

                                {utils.checkValue(item.unread, 0) > 0 && (
                                    <div className="chat--element-badge">{parseInt(item.unread) > 99 ? "99+" : item.unread}</div>
                                )}

                            </div>

                        </div>

                    </div>
                )}

            </div>
        )
    }

    /* Draw Messages */
    _messages = () => {

        /* Fields */
        const { messages } = this.state

        /* The list comes from the newest to the oldest and the column is reversed —
         * a divider drawn right after a row lands above it, so it opens the day of that very row */
        return (
            <div className="chat--messages">
                {messages.map((item, index) => {

                    /* Fields */
                    const next = messages[index + 1]
                    const previous = messages[index - 1]

                    /* Same Author — a repeated name above every bubble reads as noise */
                    const grouped = previous && previous.type === item.type
                    const divider = !next || !moment(next.createdAt).isSame(moment(item.createdAt), "day")

                    return (
                        <div className={`chat--message-row ${item.type} ${grouped ? "grouped" : ""}`} key={`${index}`}>

                            <div className={`chat--message ${item.type}`}>

                                {!grouped && (
                                    <div className="chat--message-head">
                                        <span className="chat--message-name">{utils.checkValue(item.name, "—")}</span>
                                        <span className="chat--message-type">
                                            {utils.checkValue(item.type, "-") === "player" ? t("support.playerType") : t("support.adminType")}
                                        </span>
                                    </div>
                                )}

                                <div className="chat--message-message">{utils.checkValue(item.message, "...")}</div>

                                <div className="chat--message-date">{moment(item.createdAt).format("HH:mm")}</div>

                            </div>

                            {divider && <div className="chat--divider"><span>{this._day(item.createdAt)}</span></div>}

                        </div>
                    )
                })}
            </div>
        )
    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const { chatStatus, chats, active, messageStatus, messages } = this.state

        /* Layout */
        if (chatStatus !== "ok") {
            return <Layout status={chatStatus} reload={() => this.load(true)} />
        }

        /* Empty Layout */
        if (chats.length === 0) {
            return <Layout status="empty" type="messages" />
        }

        /* Draw Messages */
        if (active) {

            /* Layout — an error, a loading state and an empty chat share the same box */
            if (messageStatus !== "ok" || messages.length === 0) {
                return (
                    <div className="chat--message-container">

                        <div className="chat--messages-layout">
                            <Layout
                                status={messageStatus === "ok" ? "empty" : messageStatus}
                                type="messages"
                                reload={messageStatus === "ok" ? null : () => this.messages(true)}
                            />
                        </div>

                        {/* Draw Input */}
                        {this._input()}

                    </div>
                )
            }

            return (
                <div className="chat--message-container">

                    {/* Draw Messages */}
                    {this._messages()}

                    {/* Draw Input */}
                    {this._input()}

                </div>
            )
        }

        /* Draw Chats */
        return this._chats()
    }

    /* Draw Left */
    _left = () => {

        /* Fields */
        const { active } = this.state

        /* Check Active */
        if (active) {
            return (
                <div onClick={() => this.setState({ active: null, message: "", messageStatus: "loading", messages: [] })} className="chat--modal-back">
                    <img src="/images/left-arrow.png" alt="Left" />
                </div>
            )
        }
    }

    /* Draw Title */
    _title = () => {

        /* Fields */
        const { active, chats } = this.state

        /* Check Active */
        if (active) {
            return (
                <div className="chat--modal-header-container">

                    <Avatar uri={utils.ava(active.ava, parseInt(active.isTester) === 1 ? "test" : null)} size={36} />

                    <div className="chat--modal-header-title">

                        <div className="chat--element-title">
                            <h2>{utils.checkValue(active.user, "—")}</h2>
                            {active.operator && <span className="chat--element-operator">{active.operator}</span>}
                        </div>

                        <span className="chat--modal-header-subtitle">{[active.player, active.game].filter((item) => item).join(" · ")}</span>

                    </div>

                </div>
            )
        }

        /* Fields */
        const unread = chats.reduce((total, item) => total + parseInt(utils.checkValue(item.unread, 0)), 0)

        return (
            <div className="chat--modal-header-container title">
                <h2>{t("support.title")}</h2>
                {unread > 0 && <span className="chat--modal-header-badge">{unread > 99 ? "99+" : unread}</span>}
            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="chat--modal"
                overlayClassName="chat--overlay"
                closeTimeoutMS={250}
            >

                {/* Draw Header */}
                <div className="chat--modal-header">
                    {this._left()}
                    {this._title()}
                    <div onClick={() => this.close()} className="chat--modal-close">
                        <img src="/images/close.png" alt="Close" />
                    </div>
                </div>

                <div className="chat--modal-container">
                    {this._content()}
                </div>

            </Modal>
        )
    }
}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(Chat)
